function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
  fill: "#F0F0F0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 12c0-4.3-2.714-7.965-6.522-9.378v18.756A10.004 10.004 0 0022 12z",
  fill: "#D80027"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 12c0 4.3 2.714 7.965 6.522 9.378V2.622A10.004 10.004 0 002 12z",
  fill: "#0052B4"
});

function SvgFlagFrance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgFlagFrance;